import { SET_SELECTED_TENANT } from "../constants/User";

export const setSelectedTenant = (tenantSchema) => ({
	type: SET_SELECTED_TENANT,
	tenantSchema,
});
